import React from 'react'
import { Box } from '@mui/material'
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material'
import { setDecimalPrecision } from 'utils/helpers'

interface TotalRowProps {
  totals: {
    amountDue: number
    amountPaid: number
    adjustment: number
    remainder: number
  }
  paymentAmount?: number
  style?: React.CSSProperties
}

const TotalsRow: React.FC<TotalRowProps> = ({ totals, paymentAmount, style }) => {
  return (
    <Box
      sx={{
        padding: '8px',
        display: 'grid',
        gridTemplateColumns: 'repeat(8, 1fr)',
        alignItems: 'center',
        borderTop: '1px solid rgba(224, 224, 224, 1)',
        fontSize: '16px',
        ...style,
      }}
      data-testid="custom-footer"
    >
      <Box sx={{ gridColumn: '1 / 5' }} data-testid="total-selected-label">
        Total Selected
      </Box>
      <Box sx={{ gridColumn: '5', justifySelf: 'flex-end', marginRight: '-8px' }} data-testid="total-amount-due">
        ${setDecimalPrecision(totals.amountDue, { decimalPrecisionOverride: 2 })}
      </Box>
      <Box
        sx={{ gridColumn: '6', justifySelf: 'flex-end', display: 'flex', alignItems: 'center', marginRight: '-8px' }}
        data-testid="total-amount-paid"
      >
        {totals.amountPaid === (paymentAmount || totals.amountDue) && (
          <CheckCircleIcon sx={{ color: '#4CAF50' }} data-testid="amount-paid-checkmark" />
        )}
        ${setDecimalPrecision(totals.amountPaid, { decimalPrecisionOverride: 2 })}
      </Box>
      <Box sx={{ gridColumn: '7', justifySelf: 'flex-end', marginRight: '-8px' }} data-testid="total-adjustment">
        ${setDecimalPrecision(totals.adjustment, { decimalPrecisionOverride: 2 })}
      </Box>
      <Box
        sx={{ gridColumn: '8', justifySelf: 'flex-end', display: 'flex', alignItems: 'center', marginRight: '-8px' }}
        data-testid="total-remainder"
      >
        {totals.remainder === 0 && <CheckCircleIcon sx={{ color: '#4CAF50' }} data-testid="remainder-checkmark" />}$
        {setDecimalPrecision(totals.remainder, { decimalPrecisionOverride: 2 })}
      </Box>
    </Box>
  )
}

export default TotalsRow
